/** What a modal overlay (NxDrawer, the NxWorkspace drawers) treats as focusable. */
export const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** The focusable elements inside `root`, in DOM order, without hidden or disabled ones. */
export function getFocusableElements(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
    (el) => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true'
  );
}

/**
 * Keeps Tab inside `panel` (a modal overlay): Tab on the last element wraps to
 * the first, Shift+Tab on the first to the last. Call it from the panel's
 * keydown; other keys are ignored.
 */
export function trapTabKey(event: KeyboardEvent, panel: HTMLElement): void {
  if (event.key !== 'Tab') return;
  const focusables = getFocusableElements(panel);
  if (focusables.length === 0) {
    event.preventDefault();
    panel.focus();
    return;
  }
  const first = focusables[0];
  const last = focusables[focusables.length - 1];
  const active = document.activeElement;
  if (event.shiftKey) {
    if (active === first || !panel.contains(active as Node)) {
      event.preventDefault();
      last.focus();
    }
  } else if (active === last || !panel.contains(active as Node)) {
    event.preventDefault();
    first.focus();
  }
}
